<template>
  <div>
    <SubSideMenu
      :subsection="'SiteScan'"
      :options="options"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import SubSideMenu from "@/components/SideMenu/SubSideMenu/SubSideMenu.vue"

export default {
  name: "SiteScanSidebar",
  components: {
    SubSideMenu
  },
  computed: {
    ...mapGetters(["siteScanNav"]),
    options() {
      return this.siteScanNav
    }
  }
}
</script>